import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useYoutubeAPI } from "../hooks/useAllCategoryData";

export default function YoutubeTestimonial({getAt,setActive}) {

  
 
  const { isLoading, error, data: youtube } = useYoutubeAPI();
  if (error) return <div>{error.message}</div>;

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  
  

  // console.log('dd',testimonial);
  return (
    <>
      {!isLoading && (
        <div className="youtube-videos">
          <Carousel
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            //autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlaySpeed={1000}
            //keyBoardControl={true}
            //customTransition="all .5"
            transitionDuration={500}
            containerClass="carousel-container"
            //removeArrowOnDeviceType={["tablet", "mobile"]}
            //deviceType={this.props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
           
            
          >
            {youtube &&
              youtube.youtube.map((y, i) => (
                <div key={i} className="testi-item">
                  <div
                    className="youtube-short"
                    alt={y.youtube_link}
                    onClick={()=> { getAt(y.youtube_link); setActive(1) }}
                  >
                    <img
                      src="/images/short-video-thumb.png"
                      alt={y.youtube_link}
                      style={{
                        backgroundImage: `url(https://i.ytimg.com/vi/${y.youtube_link}/sd2.jpg)`,
                      }}
                    />
                  </div>
                  <div className="youtube-name">{y.name}</div>
                </div>
              ))}
          </Carousel>
          
        </div>
      )}
      {isLoading && <div className='loading-div'><span>Loading...</span></div>}
    </>
  );
}
